export default __webpack_public_path__ + "static/media/completeBurger.e8eb61db.png";